// Constants
import * as Constants from "../../constants";

// Helpers
import DB from "../../helpers/db";

import { ORGANIZATIONENTITES } from "../definitions";
import { startloading, endloading } from "./loaderAction";

export const fetchOrganizationEnities = (id, flag) => async (dispatch) => {
  try {
    dispatch({
      type: ORGANIZATIONENTITES.INITIATE_ORGANIZATION_ENITIES_FETCH,
    });
    dispatch(startloading());
    await DB({
      method: Constants.EMPTY,
      url: `/organization/${id}`,
    }).then((response) => {
      if (response.data)
        dispatch({
          type: ORGANIZATIONENTITES.ORGANIZATION_ENITIES_SUCCESS,
          payload: response.data,
        });
      dispatch(endloading());
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: ORGANIZATIONENTITES.ORGANIZATION_ENITIES_FAILED,
      payload: error,
    });
  } finally {
    dispatch(endloading());
    dispatch(organizationApiCalled(flag));
  }
};

const organizationApiCalled = (flag) => async (dispatch) => {
  dispatch({
    type: ORGANIZATIONENTITES.ORGANIZATION_ENITIES_FINAL,
    payload: flag,
  });
};
